import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Convergence2023Banner from "./components/convergence-2023-banner";

const Convergence2024Pricing = () => {
  const path = "Convergence-2023%2FRecap";
  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  // Dynamic Scripts
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (pageMenuData[0]?.result[0]) {
      if (pageMenuData[0]?.result[0].javaScriptField) {
        setScriptHtmlString(pageMenuData[0].result[0].javaScriptField);
      }

      if (window.runGlobalScripts) {
        window.runGlobalScripts();
      }
    }
  }, [pageMenuData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "convergence-2023-recap-script" });
  // End Dynamic Scripts

  return (
    <>
      <Convergence2023StyleComponent />
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <Convergence2023Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <div>&nbsp;</div>
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description }}></div>
      <div>&nbsp;</div>
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.councilDescription }}></div>
    </>
  );
};

export default Convergence2024Pricing;

const Convergence2023StyleComponent = () => {
  return (
    <>
      <style>
        {`
        `}
      </style>
    </>
  );
};
